/**
 * The line that says whether the platform took what a board recorded.
 *
 * It sits in the shell rather than on the board, because the board's form has
 * closed and the person may have moved on by the time the platform answers.
 * A saved record says so and goes after a few seconds; a refused one stays
 * until it is read, with TRY AGAIN where trying again cannot file it twice.
 */
import { useEffect, useSyncExternalStore } from "react";
import s from "../../layout/AppShell.module.css";
import { t } from "../../i18n";
import { clearWrite, subscribeWrite, writeNotice } from "./writeNoticeStore";

export function WriteNotice() {
  const n = useSyncExternalStore(subscribeWrite, writeNotice, writeNotice);

  useEffect(() => {
    if (!n || n.tone !== "ok") return;
    const id = setTimeout(clearWrite, 8000);
    return () => clearTimeout(id);
  }, [n]);

  if (!n) return null;
  return (
    <div className={s.banner} role={n.tone === "warn" ? "alert" : "status"} data-testid="write-notice" data-tone={n.tone}>
      <span className={s.bannerTag}>{n.tone === "ok" ? t("SAVED") : t("NOT SAVED")}</span>
      <span>{n.text}</span>
      {n.retry && (
        <button
          type="button"
          onClick={() => {
            const again = n.retry!;
            clearWrite();
            again();
          }}
        >
          {t("Try again")}
        </button>
      )}
      <button type="button" onClick={clearWrite}>
        {t("OK")}
      </button>
    </div>
  );
}
